<template>
  <span v-on:click="onClick" class="order-by-component">
    <slot></slot>
    <span v-if="value === select" class="sort-icon-color">
      <arrow-up-icon v-if="ascending" type="up" title="Oplopend" />
      <arrow-down-icon v-if="descending" type="down" title="Aflopend" />
    </span>
    <span v-else class="sort-icon-color">
      <unfold-more-horizontal-icon title="Sorteerbaar" />
    </span>
  </span>
</template>

<script>
export default {
  name: "OrderByComponent",
  props: {
    value: {
      type: String,
      required: true,
    },
    order: {
      type: String,
      required: true
    },
    select: {
      type: String,
      default: 'created_at'
    },
    loadPageObject: {
      type: Object,
      required: false,
    }
  },
  computed: {
    ascending() {
      return this.order === 'asc';
    },
    descending() {
      return this.order === 'desc';
    }
  },
  methods: {
    onClick() {
      this.$emit('change', this.value, (this.order === 'desc' ? 'asc' : 'desc'))
    }
  }
}
</script>

<style scoped>
.order-by-component {
  cursor: pointer;
  user-select: none;
}

.order-by-component:hover {
  text-decoration: underline;
}

.sort-icon-color {
  color: #1890ff;
}
</style>
